module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('i', {
    staticClass: "icon iconsize"
  }, [_vm._v("")]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("\n    " + _vm._s(_vm.titleText) + "\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a9f6b13c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/foxconn.vue
// module id = 886
// module chunks = 34